import React, { useState, useEffect } from 'react';
import "./Rightpart.css";
import profile from "../assets/images/profile.png"; 
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from '../../api/axios';
import { Link, useNavigate } from 'react-router-dom';

export default function SupportRight() {
  const [user, setUser] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(true);
  const [subject, setSubject] = useState("Order Issue");
  const [details, setDetails] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleProfileUpdate = () => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  };

  const fetchTicketHistory = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      setLoadingHistory(true);
      const response = await axios.get("/support-tickets");
      if (response.data && response.data.success) {
        setTickets(response.data.data);
      }
      setLoadingHistory(false);
    } catch (err) {
      console.error("Error fetching support tickets:", err);
      setLoadingHistory(false);
    }
  };

  useEffect(() => {
    handleProfileUpdate();
    window.addEventListener("user-profile-updated", handleProfileUpdate);

    fetchTicketHistory();

    return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  const handleSubmitTicket = async (e) => {
    e.preventDefault();
    if (!details.trim()) {
      alert("Please enter a comment or detail for the ticket.");
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post("/support-tickets/store", {
        subject,
        details
      });

      if (response.data && response.data.success) {
        alert("Support ticket created successfully!");
        setDetails("");
        fetchTicketHistory();
      } else {
        alert(response.data.message || "Failed to create ticket.");
      }
      setSubmitting(false);
    } catch (err) {
      console.error("Error creating support ticket:", err);
      alert(err.response?.data?.message || "Something went wrong.");
      setSubmitting(false);
    }
  };

  return (
    <div className='outer-div-right'>
       <div className='dashbord-right-section'>
         <div className='dashbord-header'>
            <p className='title-dash'>Support</p>
            
           <div className='dropdown-section d-flex align-items-center'>
            <div className="dropdown">
              <button className="btn dropdown-toggle d-flex align-items-center gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                <div className='profile-name'>
                  <img src={user?.avatar_original || user?.avatar || profile} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div className='name-mail'>
                    <h4>{user?.name || "User"}</h4>
                    <p>{user?.email || user?.phone || "Email/Phone"}</p>
                  </div>
                </div>
                <ExpandMoreIcon /> 
              </button>

              <ul className="dropdown-menu ">
                <li><Link className="dropdown-item" to="/profile">Profile</Link></li>
                <li><Link className="dropdown-item" to="/support">Support</Link></li>
                <li><button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">Logout</button></li>
              </ul>
            </div>
          </div>
         </div>


         <div className='content-dashborad-outer'>
              <div className='row'>
               <div className='col-lg-12'>
                <div className='supot-form-box'>
                  <div className='box-top'>
                   <div className='sr-number'>
                      <h4>Create Ticket</h4>
                    </div>
                 </div>
                  <div className='billing-text ticket-form'>
                      <form className="ticket-form" onSubmit={handleSubmitTicket}>
                      <div className="form-row">
                        <div className="form-box">
                          <span className="label">Select Request Type</span>
                          <select value={subject} onChange={(e) => setSubject(e.target.value)}>
                            <option value="Order Issue">Order Issue</option>
                            <option value="Payment Issue">Payment Issue</option>
                            <option value="Refund Request">Refund Request</option>
                            <option value="General Query">General Query</option>
                          </select>
                        </div>
                        <div className="form-box">
                          <span className="label">Comment</span>
                          <textarea 
                            placeholder="Please describe your issue..." 
                            value={details} 
                            onChange={(e) => setDetails(e.target.value)}
                            required
                          ></textarea>
                        </div>
                      </div>
                      <button type="submit" className="ticket-submit-btn submit-btn" disabled={submitting}>
                        {submitting ? "Submitting..." : "Submit Ticket"}
                      </button>
                    </form>
                  </div>
                </div>
               </div>

                <div className='col-lg-8 col-12'>
                 <div className='support-hsty'>
                   <div className='box-top'>
                    <div className='sr-number'>
                        <h4>Latest Support History</h4>
                      </div>
                    </div>
                    <div className='billing-text ticket-data table-responsive'>
                      {loadingHistory ? (
                        <div className="text-center py-4">
                          <div className="spinner-border text-dark spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading history...</span>
                          </div>
                        </div>
                      ) : tickets.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                          No support tickets found.
                        </div>
                      ) : (
                        <table className="ticket-table">
                          <tbody>
                            {tickets.map((ticket) => (
                              <tr key={ticket.id}>
                                <td>
                                  <p>#{ticket.code}</p>
                                  <span>Support Req No</span>
                                </td>

                                <td>
                                  <p>{ticket.subject}</p>
                                  <span>Request Type</span>
                                </td>

                                <td>
                                  <p>{ticket.date}</p>
                                  <span>Date</span>
                                </td>

                                <td className={`status ${
                                  ticket.status === 'solved' ? 'approve' : 
                                  ticket.status === 'pending' || ticket.status === 'open' ? 'inprocess' : 
                                  'cancel'
                                }`}>
                                  <p>{
                                    ticket.status === 'pending' ? 'Inprocess' : 
                                    ticket.status === 'solved' ? 'Approved' : 
                                    ticket.status
                                  }</p>
                                  <span>Support Status</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                 </div>
               </div>

                <div className='col-lg-4 col-12'>
                 <div className='faq-dashbrd'>
                   <div className='box-top'>
                    <div className='sr-number'>
                        <h4>FAQS</h4>
                      </div>
                    </div>
                 </div>
                 <div className='billing-text faq-main'>

                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          What materials are used?
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                         Are your products eco-friendly?
                        </button>
                      </h2>
                      <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Do you offer customization?
                        </button>
                      </h2>
                      <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                         How do I care for the textiles?
                        </button>
                      </h2>
                      <div id="collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                          Do you provide home delivery?
                        </button>
                      </h2>
                      <div id="collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>
                  </div>
                  
                 </div>
               </div>
             </div>
         </div>
       </div>
    </div>
  );
}
